// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","span404":"NotFound_span404__K40FQ"};